import {
    useEffect,
    useRef,
} from "react";

import {
    LogOut,
    UserCircle2,
} from "lucide-react";

const EmployeeProfilePopup = ({
    open,
    onClose,
    onLogout,
    onOpenProfile,
    employee,
}) => {

    const popupRef = useRef();

    // ================= OUTSIDE CLICK =================
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                onClose();
            }
        };

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open, onClose]);

    // ================= ESC CLOSE =================
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };

        if (open) {
            window.addEventListener("keydown", handleEsc);
        }

        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            ref={popupRef}
            className="
            absolute
            right-0
            top-16
            w-64
            backdrop-blur-xl
            bg-white/90
            dark:bg-[#18181b]/95
            border
            border-[var(--border-color)]
            shadow-2xl
            rounded-2xl
            overflow-hidden
            z-50
            transition-all
        "
        >
            <div className="border-b border-[var(--border-color)] px-4 py-3">
                <p className="truncate text-sm font-black text-[var(--text-primary)]">{employee?.name || "Employee"}</p>
                <p className="mt-0.5 text-xs font-bold text-[var(--text-secondary)]">
                    Status: {employee?.availabilityStatus === "Available" ? "Active" : employee?.availabilityStatus || "Active"}
                </p>
            </div>
            <div className="p-3 flex flex-col gap-1.5">
                {/* PROFILE */}
                <button
                    onClick={onOpenProfile}
                    className="
                    w-full
                    flex
                    items-center
                    gap-2.5
                    px-3
                    py-2.5
                    rounded-xl
                    font-semibold
                    text-sm
                    text-[var(--text-primary)]
                    hover:bg-[var(--accent-primary)]/10
                    hover:text-[var(--accent-primary)]
                    transition-all
                "
                >
                    <UserCircle2 size={16} />
                    Edit Profile & Uploads
                </button>

                {/* LOGOUT */}
                <button
                    onClick={onLogout}
                    className="
                    w-full
                    flex
                    items-center
                    gap-2.5
                    px-3
                    py-2.5
                    rounded-xl
                    font-semibold
                    text-sm
                    text-red-500
                    hover:bg-red-500/10
                    transition-all
                "
                >
                    <LogOut size={16} />
                    Logout
                </button>
            </div>
        </div>
    );
};

export default EmployeeProfilePopup;
